// A cached Bunny CDN key row carries one wide directory token per playback
// namespace (see `cdn_keys` / the `sign-cdn-url` cron):
//   - `/audio/…` (legacy)          → `bunnyCDNPath`
//   - `/songs/…` (on-demand publish) → `bunnyCDNPathSongs`
// Callers pass the whole row so `signUrl` can pick the right token by the
// URL's namespace. A bare string is still accepted for back-compat and is
// treated as the legacy `/audio/` token only.
export type CdnKeyTokens = {
  bunnyCDNPath: string | null;
  bunnyCDNPathSongs?: string | null;
};

export const signUrl = (
  url: string | null,
  cdnKey: string | CdnKeyTokens | null,
) => {
  if (!url || !cdnKey) return null;

  const tokens: CdnKeyTokens =
    typeof cdnKey === "string" ? { bunnyCDNPath: cdnKey } : cdnKey;

  const isSongs = url.includes("/songs/");
  // Public previews (`/songs/<id>/preview/…`) are served unsigned via a Bunny
  // disable-token rule — never attach a token (returns null → callers fall
  // back to the raw URL). A preview environment's own media
  // (`/preview/pr-<n>/songs/…`) is signed like any song.
  if (/\/songs\/[^/]+\/preview\//.test(url)) return null;

  // On-demand `/songs/` objects need the `/songs/`-scoped token; everything
  // else keeps the historical behavior of prepending the `/audio/` token.
  const token = isSongs ? (tokens.bunnyCDNPathSongs ?? null) : tokens.bunnyCDNPath;
  if (!token) return null;

  const urlComponent = new URL(url);
  const pathname = urlComponent.pathname;
  urlComponent.pathname = `${token}${pathname}`;
  const signedUrl = urlComponent.toString();
  return signedUrl;
};
